// extracted by mini-css-extract-plugin
export var productImage = "_xn-0";